import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["iconId", "color", "staticSize", "typographySize", "showLoading"];
var useIconButton = function useIconButton(props) {
  var iconId = props.iconId,
    color = props.color,
    staticSize = props.staticSize,
    typographySize = props.typographySize,
    showLoading = props.showLoading,
    buttonProps = _objectWithoutProperties(props, _excluded);
  return {
    buttonProps: buttonProps,
    iconProps: {
      iconId: iconId,
      color: color,
      showLoading: showLoading,
      staticSize: staticSize,
      typographySize: typographySize
    }
  };
};

export { useIconButton };
//# sourceMappingURL=useIconButton.js.map
